import { render, staticRenderFns } from "./AlertaUsuaioLaudos.vue?vue&type=template&id=6d5663c7&lang=pug"
import script from "./AlertaUsuaioLaudos.vue?vue&type=script&lang=js"
export * from "./AlertaUsuaioLaudos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports